import { useCallback } from "react";

export interface ExtendedWindow extends Window {
  dataLayer?: {
    event: string;
    event_name: string;
    quote_section?: string;
    stepName?: string;
    medicalConditionsAdded?: string;
  }[];
}

type CustomEventProps = {
  event: string;
  eventName: string;
  quoteSection?: string;
  stepName?: string;
  medicalConditionsAdded?: string;
  policyExtra?: string;
  buttonLabel?: string;
};

const useGtmCustomEvent = (props: CustomEventProps) => {
  const {
    event,
    eventName,
    quoteSection,
    stepName,
    medicalConditionsAdded,
    policyExtra,
    buttonLabel,
  } = props;

  const triggerCustomEvent = useCallback(() => {
    const extendedWindow = window as ExtendedWindow;
    extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];
    const baseData: {
      event: string;
      event_name: string;
      quote_section?: string;
      step_name?: string;
      medical_conditions_added?: string;
      policy_extra?: string;
      button_label?: string;
    } = {
      event,
      event_name: eventName,
    };

    if (quoteSection) {
      baseData.quote_section = quoteSection;
    }
    if (stepName) {
      baseData.step_name = stepName;
    }
    if (medicalConditionsAdded) {
      baseData.medical_conditions_added = medicalConditionsAdded;
    }
    if (policyExtra) {
      baseData.policy_extra = policyExtra;
    }
    if (buttonLabel) {
      baseData.button_label = buttonLabel;
    }

    extendedWindow.dataLayer.push(baseData);
    return () => {};
  }, [
    event,
    eventName,
    quoteSection,
    stepName,
    medicalConditionsAdded,
    policyExtra,
    buttonLabel,
  ]);

  return triggerCustomEvent;
};

export default useGtmCustomEvent;
